import React, { createContext, useContext, useState, ReactNode } from 'react';
import { apiServices } from '../utils/apiServices';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

interface JoinWaitlistModalContextType {
    isJoinWaitlistModalOpen: boolean;
    openJoinWaitlistModal: (redirectFunction?: () => void) => void;
    closeJoinWaitlistModal: () => void;
    joinWaitlist: (email: string, callToAction: () => void) => Promise<void>;
}

const JoinWaitlistModalContext = createContext<JoinWaitlistModalContextType | undefined>(undefined);

export const useJoinWaitlistModal = () => {
    const context = useContext(JoinWaitlistModalContext);
    if (context === undefined) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};

interface JoinWaitlistModalProviderProps {
    children: ReactNode;
}

export const JoinWaitlistModalProvider: React.FC<JoinWaitlistModalProviderProps> = ({ children }) => {
    const [isJoinWaitlistModalOpen, setIsJoinWaitlistModalOpen] = useState(false);
    const navigate = useNavigate();
    const openJoinWaitlistModal = (redirectFunction?: () => void) => {
        // const email = localStorage.getItem('waitlist_email');
        // if (email && email !== '') {
            redirectFunction && redirectFunction();
        // } else {
        //     setIsJoinWaitlistModalOpen(true);
        // }
    }
    const closeJoinWaitlistModal = () => setIsJoinWaitlistModalOpen(false);
    const joinWaitlist = async (email: string) => {
        try {
            localStorage.setItem('waitlist_email', email);
            const result = await apiServices.waitlist.join(email);
            if (!result.id) {
                toast.error('Failed to join waitlist. Please try again.');
            } else if (result.is_approved) {
                toast.success('You have been approved.');
                navigate('/dashboard');
            } else {
                toast.info('You have been added to the waitlist. Please wait until you are approved. You can visit the pages, but you will not be able to use the features until you are approved.');
                navigate('/dashboard');
            }
            setIsJoinWaitlistModalOpen(false);
        } catch (error) {
            console.error('Failed to join waitlist:', error);
        }
    }

    const value = {
        isJoinWaitlistModalOpen,
        openJoinWaitlistModal,
        closeJoinWaitlistModal,
        joinWaitlist,
    };

    return (
        <JoinWaitlistModalContext.Provider value={value}>
            {children}
        </JoinWaitlistModalContext.Provider>
    );
}; 